<template>
  <div>
    <v-select
      class="mt-6 mb-n10 hidden-md-and-up"
      v-model="select"
      :items="types"
      :hint="`${select.subtitle}`"
      item-text="title"
      persistent-hint
      outlined
      single-line
      return-object
      item-color="secondary lighten-1"
      color="secondary lighten-1"
    >
      <template v-slot:item="{item}">
        <v-list two-line>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon color="secondary lighten-1">{{item.icon}}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
              <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-select>
    <v-tabs
      class="mt-8"
      v-model="tab"
      :vertical="this.$vuetify.breakpoint.name === 'xs' ? false : true"
      color="secondary lighten-1"
      background-color="transparent"
    >
      <v-tab class="white--text hidden-sm-and-down" active-class="primary darken-1 secondary--text text--lighten-1" v-for="(typeItem, typeIndex) in types" :key="typeIndex" style="height: 90px; justify-content: start!important;" >
        <v-icon class="mr-2" :color="tab !== typeIndex ? 'white' : ''" size="34">{{typeItem.icon}}</v-icon>
        <div class="py-3" style="display: flex; align-items: start; flex-direction: column;">
          <h2 style="font-weight: bold;font-size: 16px;line-height: 20px;">{{typeItem.title}}</h2>
          <h3 class="white--text" style="font-family: Roboto;font-style: normal;font-weight: 300;font-size: 12px;line-height: 16px;">{{typeItem.subtitle}}</h3>
        </div>
      </v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item class="elevation-0" v-for="(typeItem, typeIndex) in types" :key="typeIndex">
          <station-form
            :type="typeItem.value"
            :stations="stations"
            :searchResult="searchResult"
            :formInformationMessage="formInformationMessage"
            @searchStationData="searchStationData($event)"
            @openMapDialog="openMapDialog($event)"
          >
          </station-form>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <view-station-map
      ref="viewStationMap"
      :type="dataType"
      :dialog="viewStationMapDialog"
    >
    </view-station-map>
  </div>
</template>

<script>
import StationForm from './StationForm.vue'
import ViewStationMap from "./ViewStationMap.vue";
export default {
  components: { StationForm, ViewStationMap },
  name: "SelectionDataType",
  props:{
    types:{
      type: Array,
      required: true,
    },
    stations:{
      type: Array,
      required: true,
    },
    searchResult:{
      type: Object
    },
    formInformationMessage:{
      type: String,
      required: false
    },
    dataType:{
      type: String,
      required: true,
    }
  },
  data: ()=>({
    tab: undefined,
    viewStationMapDialog: false,
    select: '',
  }),
  created() {
    this.select =  this.types[0]
  },
  watch:{
    select(value){
      if(value){
        for(let index in this.types){
          if(this.types[index].value === value.value){
            this.tab = Number(index)
          }
        }
      }
    },
    tab(value){
      if(value !== undefined){
        const dataType = this.types[value];
        this.changeDataType(dataType);
      }
    }
  },
  methods:{
    changeDataType(dataType){
      this.$emit("changeDataType", dataType);
    },
    searchStationData(stationFormParams){
      const dataType = this.types[this.tab];
      this.$emit("searchStationData", { ...stationFormParams, dataType })
    },
    openMapDialog(value){
      this.$refs.viewStationMap.openMapDialog(value);
    }
  }
}
</script>

<style scoped>
.v-tab{
  text-transform: none;
}
</style>
